import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {ReCaptchaV3Service} from 'ngx-captcha';

import {Subscription} from 'rxjs';
import {WpService} from '../../../../services/wp.service';
import {LoaderService} from '../../../../services/loader.service';
import {Breadcrumb} from '../../../../types/Breadcrumb';
import {RoutesEnums, RoutesNamesEnum} from '../../../../enums/RoutesEnums';
import {ToolsService} from '../../../../services/tools.service';
import {WPPostBlog} from '../../../../types/WPPostBlog';
import {CommentStatusEnum, MediaSizeEnum, TaxonomyEnum} from '../../../../enums/WPEnums';
import {WPTag} from '../../../../types/WPTag';
import {MetaTag} from '../../../../types/MetaTag';
import {SeoMetaService} from '../../../../services/seo-meta.service';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {WPComment} from '../../../../types/WPComment';
import {HttpResponse} from '@angular/common/http';
import {StaticPagesEnum} from '../../../../enums/StaticPagesEnums';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {defaultIfEmpty, filter, finalize, skipWhile, tap} from 'rxjs/operators';
import {BlogPostUrlResolverService} from '../../services/blog-post-url-resolver.service';
import {LoaderQueueItem} from '../../../../types/LoaderQueueItem';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';
import {PageViewsGa4ResolverService} from '../../../../services/page-views-ga4-resolver.service';
import {DataLayerParamsPageViewGA4} from '../../../../types/DataLayerParamsPageViewGA4';
import {DataLayerParamsClickGA4} from '../../../../types/DataLayerParamsClickGA4';
import {AdcampaignService} from '../../../../services/adcampaign.service';
import {AppConfigService} from '../../../../services/app-config.service';
import {SearchService} from '../../../../services/search/search.service';
import {SearchReloadService} from '../../../../services/search/search-reload.service';
import {StaticBlogService} from '../../../../services/static-blog.service';
import {StaticSidebarPuffsService} from '../../../../services/static-sidebar-puffs.service';

// declare var hbspt: any;

@Component({
  selector: 'app-blog-post',
  templateUrl: './blog-post.component.html',
  styleUrls: ['./blog-post.component.scss', '../../../../../styles/misc/wp-block-library.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogPostComponent implements OnInit, OnDestroy {
  public breadcrumbs: Breadcrumb[] = [];
  public post: WPPostBlog;
  public comments: WPComment[];
  public commentsTotal: number = 0;
  public tags: WPTag[] = [];
  public hasImage: boolean;
  public publishDate: string;
  public publishDateFull: string;
  public updateDate: string;
  public updateDateFull: string;
  public mediaSizeEnum = MediaSizeEnum;
  public postTags: WPTag[];
  public postTagsString: string = '';
  public commentStatusEnum = CommentStatusEnum;
  public form: UntypedFormGroup;
  public isCommentSuccessMsgVisible: boolean = false;
  public siteKey: string;
  public commentReplyName: string = '';
  public isPostAuthorsBlockVisible: boolean = true;
  public showRelatedSection: boolean = true;
  public relatedPostsPuffsLimit: number = 4;
  public routesEnums = RoutesEnums;
  public dataLayerParamsClickGA4: DataLayerParamsClickGA4;
  public isBlogDataLoaded: boolean = false;
  public isRelatedPostsLoaded: boolean = false;
  public isMainPostLoaded: boolean = false;
  public isCommentSeectionLoaded: boolean = false;
  public imageContainerPadding: string = '0';
  public commentPolicyRouterLink: string[];
  public termsRouterLink: string[];
  public privacyRouterLink: string[];
  public pageType: DLPageTypeEnum = DLPageTypeEnum.BLOG_PAGE;
  public showMailchimpSignup: boolean = false;

  private subscriptions: Subscription[] = [];
  private commentsPage: number = 1;
  private commentsPerPage: number = 100;
  private commentsTotalPages: number = 1;
  private commentReplyId: number = 0;
  private pageTitle: string;
  private selectedTag: WPTag;

  // private codeSnippets = inject(CodeSnippetsService);
  // private loadedScripts = this.codeSnippets.loadedScripts;

  constructor(
    public wpService: WpService,
    private blogService: StaticBlogService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private tools: ToolsService,
    private metaService: SeoMetaService,
    private urlBuilder: UrlBuilderService,
    private formBuilder: UntypedFormBuilder,
    private pageViewGa4Resolver: PageViewsGa4ResolverService,
    private postUrlResolver: BlogPostUrlResolverService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private _renderer2: Renderer2,
    private el: ElementRef,
    private adCampaignService: AdcampaignService,
    private appConfigService: AppConfigService,
    private sidebarPuffsService: StaticSidebarPuffsService,
    private searchService: SearchService,
    private _change: ChangeDetectorRef,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: any,
    private reloadService: SearchReloadService,
  ) {
    this.siteKey = appConfigService.appConfig.recaptchaSiteKey;
    this.showMailchimpSignup = appConfigService.appConfig.features.showMailchimpSignup;

    // effect(() => {
    //   if (this.loadedScripts()[ScriptNameEnum.HUBSPOT_SHELL] && this.loadedScripts()[ScriptNameEnum.HUBSPOT_WEBSITE]) {
    //     this.ngZone.runOutsideAngular(() => {
    //       setTimeout(() => {
    //         this.ngZone.run(() => {
    //           this.loadDrMikaelForm();
    //         });
    //       }, 1000);
    //     });
    //   }
    // });
  }

  ngOnInit() {
    this.searchService.softResetState();
    this.commentPolicyRouterLink = this.urlBuilder.CreateStaticPageRouterLink(StaticPagesEnum.COMMENTPOLICY);
    this.termsRouterLink = this.urlBuilder.CreateStaticPageRouterLink(StaticPagesEnum.TERMS);
    this.privacyRouterLink = this.urlBuilder.CreateStaticPageRouterLink(StaticPagesEnum.PRIVACY);
    this.buildForm();
    this.isRelatedPostsLoaded = false;
    this.isMainPostLoaded = false;
    this.isCommentSeectionLoaded = false;
    this.isBlogDataLoaded = false;
    this.onRoutingUpdate();
    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.onRoutingUpdate();
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.wpService.removeSchema();
  }

  public commentReply(id: number, name: string): void {
    this.commentReplyId = id;
    this.commentReplyName = name;
    this.scrollToCommentForm();
  }

  public cancelCommentReply(): void {
    this.commentReplyId = 0;
    this.commentReplyName = '';
  }

  // public postComment(): void {
  //   this.reCaptchaV3Service.execute(
  //     this.siteKey,
  //     'post_comment',
  //     (token) => {
  //       this.form.controls.recaptcha.setValue(token);
  //       (Object as any).values(this.form.controls).forEach((control) => control.markAllAsTouched());
  //       if (this.form.valid) {
  //         const queryId: number = this.loaderService.generateQueueId();
  //         const queryItem: LoaderQueueItem = {
  //           id: queryId,
  //           title: '',
  //           description: '',
  //         };
  //         this.loaderService.addToQueue(queryItem);
  //         this.subscriptions.push(
  //           this.blogService
  //             .AddNewComment(this.getCommentObjectFromFormData())
  //             .pipe(
  //               finalize(() => {
  //                 this.loaderService.removeFromQueue(queryId);
  //               }),
  //             )
  //             .subscribe(
  //               (result) => this.processNewComment(result),
  //               (error) => console.error(error),
  //             ),
  //         );
  //       }
  //     },
  //     {
  //       useGlobalDomain: false,
  //     },
  //     (error) => console.log(error),
  //   );
  // }

  public onPuffsNumberUpdate(numberOfPosts: number): void {
    this.showRelatedSection = !this.tools.isNil(numberOfPosts) && numberOfPosts > 0;
    this.isRelatedPostsLoaded = true;
    this.onDataLoadingFinish();
  }

  public trackByMethodComments(i: number, el: WPComment) {
    return el ? el.id : null;
  }

  public trackByMethodSubcomments(i: number, el: WPComment) {
    return el ? el.id : null;
  }

  private onRoutingUpdate(): void {
    this.reloadService.updateParams(this.route.snapshot.params, this.route.snapshot.queryParams);
    this.isMainPostLoaded = false;
    this.isRelatedPostsLoaded = false;
    this.isCommentSeectionLoaded = false;
    this.isBlogDataLoaded = false;
    const isRedirected: boolean = this.isRedirectedAfterInitUrlResolverAndUpdateState();
    this.loadBlogData(isRedirected);
  }

  private isRedirectedAfterInitUrlResolverAndUpdateState(): boolean {
    const isRedirectedInResolver: boolean = this.postUrlResolver.cleanUpUrl(this.route.snapshot);
    this.postUrlResolver.resetState();
    this.postUrlResolver.processRouteAndQueryParams(this.route.snapshot.params, this.route.snapshot.queryParams);
    return isRedirectedInResolver;
  }

  private processNewComment(comment: WPComment): void {
    this.showCommentSuccessMsg();
    this.cancelCommentReply();
    this.form.reset();
    (Object as any).values(this.form.controls).forEach((control) => {
      control.markAsUntouched();
      control.setErrors(null);
    });
  }

  private loadBlogData(isRedirected: boolean): void {
    const queryId: number = this.loaderService.generateQueueId();
    const queryItem: LoaderQueueItem = {
      id: queryId,
      title: '',
      description: '',
    };
    this.loaderService.addToQueue(queryItem);
    this.subscriptions.push(
      this.wpService
        .GetTaxonomyItems(TaxonomyEnum.BLOG_TAG)
        .pipe(
          finalize(() => {
            this.loaderService.removeFromQueue(queryId);
          }),
        )
        .subscribe(
          (result) => {
            this.processTags(result);
            this.loadBlogPostData(isRedirected);
          },
          (error) => {
            this.postUrlResolver.processFailToGetPostData(
              error,
              `taxonomy get: ${TaxonomyEnum.BLOG_TAG} ${this.postUrlResolver.isPreview}`,
            );
            this.isBlogDataLoaded = true;
            this.isMainPostLoaded = true;
            this.isRelatedPostsLoaded = true;
            this.isCommentSeectionLoaded = true;
            this.onDataLoadingFinish();
          },
        ),
    );
  }

  private loadBlogPostData(isRedirected: boolean): void {
    const queryId: number = this.loaderService.generateQueueId();
    const queryItem: LoaderQueueItem = {
      id: queryId,
      title: '',
      description: '',
    };
    this.loaderService.addToQueue(queryItem);
    this.subscriptions.push(
      this.blogService
        .GetBlogPostById(this.postUrlResolver.postId)
        .pipe(
          filter((result) => this.filterPost(result)),
          defaultIfEmpty(null),
          tap((result) => this.conditionalRedirectToBlogList(result)),
          skipWhile((result) => result === null),
          finalize(() => {
            this.loaderService.removeFromQueue(queryId);
          }),
        )
        .subscribe(
          (result) => {
            this.processBlogResults(result, isRedirected);
          },
          (error) => {
            this.postUrlResolver.processFailToGetPostData(
              error,
              `blog post get: ${this.postUrlResolver.postId} ${this.postUrlResolver.isPreview}`,
            );
            this.isMainPostLoaded = true;
            this.isRelatedPostsLoaded = true;
            this.isCommentSeectionLoaded = true;
            this.onDataLoadingFinish();
          },
        ),
    );
  }

  private conditionalRedirectToBlogList(result: WPPostBlog): void {
    if (result === null) {
      this.postUrlResolver.processFailToGetPostData('No items to show', 'Preview item filtered out');
    }
  }

  private filterPost(result: WPPostBlog): boolean {
    return (
      this.postUrlResolver.isPreview ||
      (result && !result.acf) ||
      (result && result.acf && !result.acf.isPreview) ||
      (result && result.acf && result.acf.isPreview === false)
    );
  }

  private loadComments(): void {
    const queryId: number = this.loaderService.generateQueueId();
    const queryItem: LoaderQueueItem = {
      id: queryId,
      title: '',
      description: '',
    };
    this.loaderService.addToQueue(queryItem);
    this.subscriptions.push(
      this.blogService
        .GetBlogCommentsLatestResponse(this.commentsPage, this.postUrlResolver.postId)
        .pipe(
          finalize(() => {
            this.loaderService.removeFromQueue(queryId);
          }),
        )
        .subscribe(
          (result) => this.processCommentsResults(result),
          (error) => {
            this.isCommentSeectionLoaded = true;
            console.error(error);
            this.onDataLoadingFinish();
          },
        ),
    );
  }

  private processCommentsResults(result: HttpResponse<WPComment[]>): void {
    if (result != null && result.body != null) {
      this.comments = [...this.comments, ...result.body];
      this.commentsTotalPages = parseInt(result?.headers?.get('X-WP-TotalPages'), 10);
      this.commentsTotal = parseInt(result?.headers?.get('X-WP-Total'), 10);
    }

    if (this.commentsPage < this.commentsTotalPages) {
      this.commentsPage++;
      this.loadComments();
    }
    this.isCommentSeectionLoaded = true;
    this.onDataLoadingFinish();
  }

  private processTags(result: WPTag[]) {
    this.tags = result;
    this.isBlogDataLoaded = true;
    this.onDataLoadingFinish();
  }

  private processBlogResults(results: WPPostBlog, isRedirected: boolean): void {
    const wasRedirectedInvalidSlug: boolean = this.postUrlResolver.conditionalRedirectToValidSlug(results);
    results.comment_status = CommentStatusEnum.CLOSED;
    this.post = results;
    this.selectedTag = this.wpService.getTagById(this.post.blogtag[0], this.tags);
    this.comments = [];
    this.sidebarPuffsService.reloadCombinedPuffs(
      RoutesEnums.BLOG,
      null,
      this.post.care_provider_unit_type,
      null,
      null,
      [this.post.id],
    );
    this.calculateImageContainerPadding();
    this.buildBreadcrumbs();
    this.updateMetaTags();
    this.scrollToTop();
    this.setBasicPostData();
    this.loadComments();
    if (isRedirected === false && wasRedirectedInvalidSlug === false) {
      // this.loadAdCampaignOwnersAndTriggerDataLayerTracking(); ignore assigned taxonomies and ask for campaign ID
      this.loadAdCampaignOwnerAndTriggerDataLayerTracking();
      // this.conditionalLoadDrMikaelForm();
    }
    this.wpService.removeSchema();
    this.wpService.addSchema(this.post, null, null, null, null);
    this.showRelatedSection = true;
    this.isMainPostLoaded = true;
    this.onDataLoadingFinish();
  }

  private loadAdCampaignOwnersAndTriggerDataLayerTracking(): void {
    this.subscriptions.push(
      this.adCampaignService
        .getAdCampaignOwners(this.post.acf.campaignCareServiceType, this.post.acf.campaignSymptom)
        .subscribe(
          (result) => {
            this.triggerDataLayerTracking(result && result.length > 0 ? result[0] : null);
          },
          (error) => {
            this.triggerDataLayerTracking(null);
          },
        ),
    );
  }

  private loadAdCampaignOwnerAndTriggerDataLayerTracking(): void {
    if (!this.tools.isNil(this.post.acf.adCampaignId) && this.post.acf.adCampaignId.toString() !== '') {
      this.subscriptions.push(
        this.adCampaignService.getAdCampaignOwner(this.post.acf.adCampaignId).subscribe(
          (result) => {
            this.triggerDataLayerTracking(result);
          },
          (error) => {
            this.triggerDataLayerTracking(null);
          },
        ),
      );
    } else {
      this.triggerDataLayerTracking(null);
    }
  }

  private triggerDataLayerTracking(adCampaignOwner: number): void {
    const customGa4Params: DataLayerParamsPageViewGA4 = this.wpService.createDataLayerGa4CustomParams(
      this.post,
      DLPageTypeEnum.BLOG_PAGE,
      this.pageTitle,
    );
    customGa4Params.adCampaignOwner = adCampaignOwner;
    this.pageViewGa4Resolver.trackPageView(customGa4Params);

    this.dataLayerParamsClickGA4 = this.wpService.createDataLayerGa4ClickCustomParams(
      this.post,
      '',
      DLPageTypeEnum.BLOG_PAGE,
      this.pageTitle,
    );
  }

  private setBasicPostData(): void {
    this.hasImage = this.post && this.post.featured_media > 0;
    this.publishDate = this.wpService.getFormattedDate(this.post.date);
    this.publishDateFull = this.wpService.getFormattedDate(this.post.date, 'full');
    this.updateDate = this.wpService.getFormattedDate(this.post.modified);
    this.updateDateFull = this.wpService.getFormattedDate(this.post.modified, 'full');
    this.filterTags();
  }

  private filterTags(): void {
    this.postTags = [];
    const tagsStr: string[] = [];
    this.post.blogtag.forEach((tagId) => {
      const wpTag: WPTag = this.wpService.getTagById(tagId, this.tags);
      if (!this.tools.isNil(wpTag)) {
        this.postTags.push(wpTag);
        tagsStr.push(wpTag.name);
      }
    });
    this.postTagsString = ' | ' + tagsStr.join(', ');
  }

  private buildBreadcrumbs() {
    this.breadcrumbs = [];
    this.breadcrumbs.push({
      routeParams: ['/', RoutesEnums.BLOG],
      routeQueryParams: null,
      anchor: RoutesNamesEnum.BLOG,
    });

    if (!this.tools.isNil(this.selectedTag)) {
      this.breadcrumbs.push({
        routeParams: ['/', RoutesEnums.BLOG, RoutesEnums.TAG, `${this.selectedTag.id}-${this.selectedTag.slug}`],
        routeQueryParams: null,
        anchor: this.selectedTag.name,
      });
    }

    this.breadcrumbs.push({
      routeParams: null,
      routeQueryParams: null,
      anchor: this.post.title.rendered,
    });
  }

  private scrollToTop(): void {
    this.tools.scrollTo();
  }

  private scrollToCommentForm(): void {
    this.tools.scrollTo('comment-form', 0, -150);
  }

  private updateMetaTags(): void {
    const metaTags: MetaTag[] = [];
    const suffix = ' - Vården.se';
    const url = this.urlBuilder.CreateStaticLink(
      this.urlBuilder.CreateBlogPostRouterLink(this.post.id, decodeURI(this.post.slug)),
    );
    const title = this.post.acf != null ? this.post.acf.seoTitle : '';
    this.pageTitle = title + suffix;

    metaTags.push({
      value: title + suffix,
      type: 'title',
      field: 'title',
    });

    metaTags.push({
      value: title + suffix,
      type: 'property',
      field: 'og:title',
    });

    metaTags.push({
      value: 'website',
      type: 'property',
      field: 'og:type',
    });

    metaTags.push({
      value: url,
      type: 'property',
      field: 'og:url',
    });

    metaTags.push({
      value: this.post.acf != null ? this.post.acf.seoDescription : '',
      type: 'name',
      field: 'description',
    });

    metaTags.push({
      value: this.post.acf != null ? this.post.acf.seoDescription : '',
      type: 'property',
      field: 'og:description',
    });

    metaTags.push({
      value: this.appConfigService.appConfig.siteName,
      type: 'property',
      field: 'og:site_name',
    });

    if (!this.tools.isNil(this.post.acf.mainImage) && this.post.acf.mainImage.id > 0) {
      metaTags.push({
        value: this.wpService.getImageFlatUrl(this.post.acf.mainImage),
        type: 'property',
        field: 'og:image',
      });

      metaTags.push({
        value: this.wpService.getImageFlatUrl(this.post.acf.mainImage),
        type: 'name',
        field: 'twitter:image',
      });

      metaTags.push({
        value: 'summary_large_image',
        type: 'name',
        field: 'twitter:card',
      });
    }

    this.metaService.updateMetaTags(metaTags);
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.pattern("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]{2,})+$")]],
      content: ['', [Validators.required]],
      datapolicy: [false, [Validators.pattern('true')]],
      commentpolicy: [false, [Validators.pattern('true')]],
      recaptcha: ['', [Validators.required]],
    });
  }

  private showCommentSuccessMsg(): void {
    this.isCommentSuccessMsgVisible = true;
    this._change.markForCheck();
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.isCommentSuccessMsgVisible = false;
          this._change.markForCheck();
        });
      }, 20000);
    });
  }

  private getCommentObjectFromFormData(): WPComment {
    const commentObj: WPComment = {
      author_email: this.form.value.email,
      author_name: this.form.value.name,
      author_url: '',
      author_user_agent: '',
      content: this.form.value.content,
      parent: this.commentReplyId,
      post: this.postUrlResolver.postId,
      'g-recaptcha-response': this.form.value.recaptcha,
    };
    return commentObj;
  }

  private onDataLoadingFinish(): void {
    this._change.markForCheck();
  }

  // private conditionalLoadDrMikaelForm() {
  //   if (isPlatformBrowser(this.platformId) && this.post.acf.loadDrMikaelForm === true) {
  //     const hsScript: string = '//js.hsforms.net/forms/shell.js';
  //     this.codeSnippets.loadExternalScript(this._renderer2, hsScript, ScriptNameEnum.HUBSPOT_SHELL);
  //     const hsPageScript: string = '//js.hs-scripts.com/7080361.js';
  //     this.codeSnippets.loadExternalScript(this._renderer2, hsPageScript, ScriptNameEnum.HUBSPOT_WEBSITE);
  //   }
  // }
  //
  // private loadDrMikaelForm() {
  //   hbspt.forms.create({
  //     region: 'na1',
  //     portalId: '7080361',
  //     formId: 'a2046569-c2c7-41ad-a926-709b200ecc60',
  //     target: '#drMikaelForm',
  //   });
  // }

  private calculateImageContainerPadding(): void {
    if (this.post.acf.mainImage) {
      this.imageContainerPadding = `${this.post.acf.mainImage.height / this.post.acf.mainImage.width}%`;
    }
  }
}
